import utils from "client/utils/index";

const initializeCourseProgress = (userActivated, courses) => {
  const courseProgress = {};

  courses.forEach((course) => {
    const { courseId, courseNo, courseVideos } = course;

    const videoProgressObj = {};

    courseVideos.forEach((video) => {
      const { videoId } = video;

      videoProgressObj[videoId] = { videoStatus: "incomplete" };
    });

    const courseProgressObj = {
      courseNo: courseNo.toString(),
      courseUnlocked: userActivated ? true : courseNo === 1 ? true : false,
      courseProgress: "0",
      videoProgress: videoProgressObj,
    };

    courseProgress[courseId] = courseProgressObj;
  });

  return courseProgress;
};

const unlockNextCourse = (currentUser, courseNo, progressObj) => {
  const newProgressObj = { ...progressObj };

  const courses = utils.removeKeyFromObj(currentUser.uid, newProgressObj);

  const nextCourseNo = (Number(courseNo) + 1).toString();

  const updatedNextCourseObj = {};
  for (const [key, value] of Object.entries(courses)) {
    if (value.courseNo === nextCourseNo) {
      updatedNextCourseObj[key] = {
        ...courses[key],
        courseUnlocked: true,
      };
    }
  }

  return updatedNextCourseObj;
};

const updateCourseProgress = (courseId, courseObj) => {
  const course = courseObj[courseId];
  const { videoProgress } = course;

  const totalCount = Object.keys(videoProgress).length;
  let completedCount = 0;
  // eslint-disable-next-line no-unused-vars
  for (const [key, value] of Object.entries(videoProgress)) {
    if (value.videoStatus === "completed") {
      completedCount += 1;
    }
  }

  const newCourseProgress = parseInt(
    (completedCount / totalCount) * 100
  ).toString();

  const newCourseObj = {
    [courseId]: { ...course, courseProgress: newCourseProgress },
  };

  return newCourseObj;
};

const updateOverallProgress = (currentUser, allProgressObj) => {
  const newAllProgressObj = { ...allProgressObj };

  const courses = utils.removeKeyFromObj(currentUser.uid, newAllProgressObj);

  const courseKeys = Object.keys(courses);
  const overallProgressArray = [];

  let newLevel = "1";

  // Simpler calculation for updated level
  const incompleteCourses = {};

  for (const [key, value] of Object.entries(courses)) {
    if (value.courseProgress < "100") {
      incompleteCourses[key] = value;
    }
  }

  const processedValues = Object.values(incompleteCourses);

  newLevel = Math.min(
    ...processedValues.map((obj) => obj["courseNo"])
  ).toString();

  // // Time consuming calculation for updated level
  // const descendedKeys = courseKeys.sort(function (a, b) {
  //   return b - a;
  // });

  // for (var i = 0; i < descendedKeys.length; i++) {
  // const courseToCheck = courses[descendedKeys[i]];

  //   if (courseToCheck.courseProgress === "100") {
  //     const updatedLevel = (Number(courseToCheck.courseNo) + 1).toString();
  //     newLevel = updatedLevel;
  //     break;
  //   }
  // }

  for (var j = 0; j < courseKeys.length; j++) {
    const courseToCheck = courses[courseKeys[j]];
    const { courseProgress } = courseToCheck;
    const numericCourseProgress = Number(courseProgress);

    overallProgressArray.push(numericCourseProgress);
  }

  const newOverallProgress = parseInt(
    (overallProgressArray.reduce((a, b) => a + b, 0) /
      (100 * overallProgressArray.length)) *
      100
  ).toString();

  const newOverallProgressObj = {
    [currentUser.uid]: {
      overallProgress: newOverallProgress,
      level: newLevel,
    },
  };

  return newOverallProgressObj;
};

const updateProgressData = (
  currentUser,
  currentProgress,
  selectedCourse,
  videoId
) => {
  const selectedCourseId = selectedCourse[0].courseId;
  const selectedCourseNo = selectedCourse[0].courseNo;

  const selectedCourseProgress = currentProgress[selectedCourseId];

  const updatedVideoProgressObj = selectedCourseProgress.videoProgress[videoId];

  updatedVideoProgressObj.videoStatus = "completed";

  const allVideosObj = selectedCourseProgress.videoProgress;
  allVideosObj[videoId] = updatedVideoProgressObj;

  const newSelectedCourseObj = {
    [selectedCourseId]: {
      ...selectedCourseProgress,
      videoProgress: allVideosObj,
    },
  };

  const finalSelectedCourseObj = updateCourseProgress(
    selectedCourseId,
    newSelectedCourseObj
  );

  let allUpdatesObj = { ...finalSelectedCourseObj };

  if (finalSelectedCourseObj[selectedCourseId].courseProgress === "100") {
    const nextCourseUnlockedObj = unlockNextCourse(
      currentUser,
      selectedCourseNo,
      currentProgress
    );

    allUpdatesObj = { ...allUpdatesObj, ...nextCourseUnlockedObj };
  }

  const updatedProgress = { ...currentProgress, ...finalSelectedCourseObj };

  const newOverallProgressObj = updateOverallProgress(
    currentUser,
    updatedProgress
  );

  allUpdatesObj = { ...allUpdatesObj, ...newOverallProgressObj };

  return allUpdatesObj;
};

const handlers = {
  initializeCourseProgress,
  unlockNextCourse,
  updateCourseProgress,
  updateProgressData,
};

export default handlers;
